const atividades = [
  { codigo: 11002, nome: "Canto coral" },
  { codigo: 11006, nome: "Banda" },
  { codigo: 11011, nome: "Iniciação musical" },
  { codigo: 11012, nome: "Percussão corporal" },
  { codigo: 11013, nome: "Composição e produção musical digital" },
  { codigo: 11014, nome: "Escrita Musical" },
  { codigo: 11015, nome: "Instalação sonora" },
  { codigo: 11016, nome: "Trilha sonora para filmes e games" },
  { codigo: 12003, nome: "Desenho" },
  { codigo: 12004, nome: "Escultura e Cerâmica" },
  { codigo: 12005, nome: "Grafite" },
  { codigo: 12007, nome: "Pintura" },
  { codigo: 12008, nome: "Arte e inteligência artificial" },
  { codigo: 12009, nome: "Arte digital" },
  { codigo: 12010, nome: "Fotografia" },
  { codigo: 12011, nome: "Intervenção Urbana" },
  { codigo: 12012, nome: "Videoarte" },
  { codigo: 12013, nome: "Instalação artística" },
  { codigo: 12014, nome: "História em Quadrinhos" },
  { codigo: 13001, nome: "Exibição" },
  {
    codigo: 13002,
    nome: "Produção audiovisual: filmes, vídeo-minuto, instalações, animações, remidiações",
  },
  { codigo: 14001, nome: "Teatro" },
  { codigo: 14002, nome: "Danças" },
  { codigo: 14004, nome: "Circo-teatro e Palhaçaria" },
  { codigo: 15001, nome: "Capoeira" },
  { codigo: 15002, nome: "Artesanato" },
  { codigo: 15003, nome: "Folguedos, brinquedos e brincadeiras populares" },
  { codigo: 15004, nome: "Contos" },
  { codigo: 16001, nome: "Educação Patrimonial" },
  { codigo: 16002, nome: "Passeios e visitas a monumentos locais" },
  { codigo: 16003, nome: "Projetos de preservação do patrimônio" },
  { codigo: 17004, nome: "Cantinho de Leitura" },
  { codigo: 17002, nome: "Línguas Estrangeiras" },
  { codigo: 17005, nome: "Contação de histórias" },
  {
    codigo: 19001,
    nome: "Eventos de celebração à Diversidade Cultural na Escola (Feira das Nações, Feira dos Estados, etc.)",
  },
  { codigo: 19002, nome: "Promoção do respeito à Diversidade Cultural" },
  { codigo: 19003, nome: "Visita à Equipamentos de Cultura da Localidade" },
  { codigo: 19004, nome: "Passeios externos" },
  { codigo: 19005, nome: "Festivais e mostras artísticas" },
  { codigo: 19006, nome: "Curadoria" },
  { codigo: 19007, nome: "Performance" },
  { codigo: 19999, nome: "Outra categoria de Cultura, Artes e Educação Patrimonial" },
  { codigo: 21001, nome: "Recreação (Brinquedoteca e Jogos)" },
  { codigo: 21002, nome: "Brincar livre" },
  { codigo: 21003, nome: "Jogos específicos para a Educação Infantil" },
  { codigo: 22007, nome: "Yoga" },
  { codigo: 22009, nome: "Tênis de campo" },
  { codigo: 22011, nome: "Atletismo" },
  { codigo: 22012, nome: "Badminton" },
  { codigo: 22014, nome: "Basquete" },
  { codigo: 22015, nome: "Ciclismo" },
  { codigo: 22018, nome: "Futebol" },
  { codigo: 22019, nome: "Futsal" },
  { codigo: 22020, nome: "Ginástica (rítmica, artística, acrobática)" },
  { codigo: 22021, nome: "Handebol" },
  { codigo: 22022, nome: "Judô" },
  { codigo: 22023, nome: "Karatê" },
  { codigo: 22024, nome: "Luta Olímpica" },
  { codigo: 22025, nome: "Natação" },
  { codigo: 22026, nome: "Taekwondo" },
  { codigo: 22027, nome: "Tênis de Mesa" },
  { codigo: 22028, nome: "Voleibol" },
  { codigo: 22029, nome: "Vôlei de Praia" },
  { codigo: 22032, nome: "Xadrez tradicional/Xadrez virtual" },
  { codigo: 22033, nome: "Balé" },
  { codigo: 22034, nome: "Skate e esportes radicais urbanos" },
  { codigo: 22035, nome: "Habilidades circenses" },
  { codigo: 29999, nome: "Outra categoria de Esporte e Lazer" },
  { codigo: 31001, nome: "Matemática" },
  { codigo: 31016, nome: "Linguagens" },
  { codigo: 31017, nome: "Ciências da Natureza" },
  { codigo: 31018, nome: "Ciências Humanas e Sociais." },
  { codigo: 39999, nome: "Outra categoria de Acompanhamento Pedagógico" },
  { codigo: 41007, nome: "Educação em Direitos Humanos" },
  { codigo: 41001, nome: "Direitos da criança e do adolescente" },
  { codigo: 41014, nome: "Respeito e valorização do idoso" },
  { codigo: 41015, nome: "Educação para o trânsito" },
  { codigo: 41016, nome: "Estudo do Estatuto do Idoso" },
  { codigo: 41017, nome: "Legislação e conduta no Trânsito" },
  { codigo: 41018, nome: "Parcerias com os órgãos de Trânsito" },
  { codigo: 41019, nome: "Ações de respeito à diversidade" },
  { codigo: 41020, nome: "Constituição, direitos e deveres do cidadão" },
  { codigo: 41021, nome: "Estudo do Estatuto da Criança e do Adolescente" },
  { codigo: 41022, nome: "Ações de integração Família e Escola" },
  { codigo: 41023, nome: "Ações de integração Comunidade e Escola" },
  { codigo: 41024, nome: "Vida Familiar e Social" },
  { codigo: 41025, nome: "Protagonismo Estudantil, Projeto de Vida, Agremiações Estudantis" },
  { codigo: 41026, nome: "Cultura de paz" },
  { codigo: 41027, nome: "Direitos dos refugiados e imigrantes" },
  { codigo: 41028, nome: "Educação Inclusiva" },
  { codigo: 41029, nome: "Democracia e participação social" },
  { codigo: 10103, nome: "Iniciação Científica" },
  { codigo: 13301, nome: "Educação Ambiental e Desenvolvimento Sustentável" },
  {
    codigo: 13104,
    nome: "Conservação do solo e composteira: canteiros sustentáveis (horta) e/ou jardinagem escolar",
  },
  { codigo: 13303, nome: "Reciclagem" },
  { codigo: 13304, nome: "Reflorestamento - Plantio de árvores" },
  { codigo: 13305, nome: "Consumo consciente de água" },
  { codigo: 13306, nome: "Escolas sustentáveis e COM-vida" },
  { codigo: 13307, nome: "Coleta seletiva/ Gestão de resíduos" },
  { codigo: 13308, nome: "Captação e aproveitamento de Água de Chuva" },
  { codigo: 13309, nome: "Uso de energias alternativas na escola" },
  { codigo: 13310, nome: "Projetos de pesquisa na escola e entorno" },
  { codigo: 14101, nome: "Fotografia" },
  { codigo: 14102, nome: "História em Quadrinhos" },
  { codigo: 14103, nome: "Jornal Escolar" },
  { codigo: 14104, nome: "Rádio Escolar" },
  { codigo: 14105, nome: "Vídeo" },
  { codigo: 14106, nome: "Playlists comentadas, fanfics, fanzines,e-zines, fanvídeos, fanclipes" },
  { codigo: 14201, nome: "Robótica Educacional" },
  { codigo: 14202, nome: "Tecnologias Educacionais" },
  { codigo: 14203, nome: "Ambientes de Redes Sociais" },
  { codigo: 14204, nome: "Pensamento computacional e cultura digital" },
  { codigo: 14205, nome: "Computação, programação" },
  { codigo: 14206, nome: "Ética e segurança digital" },
  {
    codigo: 14999,
    nome: "Outra Categoria de Comunicação, Uso de Mídias e Cultura Digital e Tecnológica",
  },
  { codigo: 15101, nome: "Memória e História das Comunidades Tradicionais" },
  { codigo: 15201, nome: "Memória e História das Cultura Afro-Brasileira e Africana" },
  { codigo: 15301, nome: "Memória e História das Culturas e Indígenas" },
  { codigo: 15401, nome: "Respeito à Diversidade Étnico-Racial" },
  { codigo: 15402, nome: "A contribuição dos povos no Multiculturalismo Brasileiro" },
  { codigo: 17101, nome: "Educação para o Consumo Sustentável" },
  { codigo: 17102, nome: "Fomento da Economia Solidária e Criativa" },
  { codigo: 17201, nome: "Educação Financeira" },
  { codigo: 17202, nome: "Economia" },
  { codigo: 17301, nome: "Controle social do gasto público" },
  { codigo: 17302, nome: "Educação Tributária" },
  { codigo: 17401, nome: "Direitos e Deveres do Trabalhador" },
  { codigo: 17402, nome: "O mundo do trabalho" },
  { codigo: 19101, nome: "Promoção da Saúde" },
  { codigo: 19102, nome: "Higiene e Cuidados Pessoais/ Higiene Pessoal" },
  { codigo: 19103, nome: "Saúde Bucal" },
  { codigo: 19104, nome: "Campanhas de vacinação" },
  { codigo: 19105, nome: "Educação em saúde reprodutiva" },
  { codigo: 19106, nome: "Prevenção ao uso de Álcool, Tabaco e Drogas" },
  { codigo: 19107, nome: "Primeiros Socorros" },
  { codigo: 19108, nome: "Ações de prevenção a doenças epidemiológicas" },
  { codigo: 19109, nome: "Meditação" },
  { codigo: 19110, nome: "Saúde Mental e Bem-Estar Psicológico" },
  { codigo: 19201, nome: "Desenvolvimento de competências socioemocionais" },
  { codigo: 19202, nome: "Atividades de autoconhecimento, identificação e gestão de sentimento" },
  { codigo: 19203, nome: "Atividades de empatia e gestão de conflitos" },
  { codigo: 20101, nome: "Educação alimentar e nutricional" },
  { codigo: 20102, nome: "Estudos dos aspectos nutricionais dos alimentos" },
  { codigo: 20103, nome: "Ações de Prevenção dos distúrbios alimentares" },
  { codigo: 20104, nome: "Elaboração de Cardápio Contextualizado local" },
];

export default atividades;
